import { Component, OnInit, ViewChild, Output,EventEmitter } from '@angular/core';

import { Storyboard } from 'app/models/storyboard';
import { File } from 'app/models/file';
import { StoryboardService } from 'app/services/storyboard.service';
import { CompetitionService } from 'app/services/competition.service';
import { ModalPanelComponent } from 'app/shared/components/modal-panel/modal-panel.component';

@Component({
  selector: 'app-modal-storyboard',
  templateUrl: './modal-storyboard.component.html',
  styleUrls: ['./modal-storyboard.component.scss']
})
export class ModalStoryboardComponent implements OnInit {

  @ViewChild('modalPanel') modalPanel: ModalPanelComponent;
  @ViewChild('storyboardForm') storyboardForm: any;
  storyboard: Storyboard;
  title: string;
  buttonTitle: string;
  @Output()
  close= new EventEmitter();
  constructor(
    private storyboardService: StoryboardService,
    private competitionService: CompetitionService
  ) {
    this.storyboard = new Storyboard(null, competitionService.getCompetitionId(),
                                     null, null, null, null, null, new Array<File>());
  }

  ngOnInit() {
  }

  onSave() {
    if (this.storyboard.id) {
      this.storyboardService.update(this.storyboard)
        .subscribe(res => this.modalPanel.onClose());
    } else {
      this.storyboardService.create(this.storyboard)
        .subscribe(res => this.modalPanel.onClose());
    }
    this.close.emit();
  }
}
